(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('FiltroRelatorio30DiasValidator', FiltroRelatorio30DiasValidator);

  function FiltroRelatorio30DiasValidator() {

    var validator = {
      getErrors: getErrors
    };


    return validator;

    /**
    * Mês inicial é obrigatório
    * Mês inicial não deve ser anterior a 12 meses em relação à data atual
    *
    * Mês final é obrigatório
    * Mês final não deve ser, no máximo, dois meses anterior em relação à data atual
    *
    * Mês inicial não pode ser posterior ao mês final
    * Mês inicial e final podem ser iguais
    *
    * Frequência não é obrigatório
    * Frequência não deve ser maior do que a quantidade de meses especificada no período
    *
    * Quantidade de dias é obrigatório
    * Quantidade de dias não pode ser menor do que 30
    *
    * Total de feitos reconhecidos não é obrigatório
    * Total de feitos impugnados não é obrigatório
    * Total de feitos sem justificativa não é obrigatório
    */
    function getErrors(filter) {

      var errors = [];

      var periodoInicial = moment(filter.periodoInicial, 'YYYYMM');
      var periodoFinal = moment(filter.periodoFinal, 'YYYYMM');
      var mesAtual = moment();
      var mesPassado = moment().subtract(1, 'months');
      var frequencia = filter.frequencia;

      if (frequencia !== null && (frequencia > 12 || frequencia < 0)) { errors.push('corregedoria.relatorio30dias.filtro.validacao.frequencia.fora.range'); }
      if (isBlank(filter.periodoInicial)) { errors.push('corregedoria.relatorio30dias.filtro.validacao.mes.inicial.obrigatorio'); }
      if (isBlank(filter.periodoFinal)) { errors.push('corregedoria.relatorio30dias.filtro.validacao.mes.final.obrigatorio'); }

      if (periodoInicial.isValid() && periodoFinal.isValid() && periodoInicial.isAfter(periodoFinal)) { errors.push('corregedoria.relatorio30dias.filtro.validacao.mes.inicial.invalido'); }
      if (periodoInicial.isValid() && periodoInicial.isBefore(moment().startOf('month').subtract(1, 'years'))) { errors.push('corregedoria.relatorio30dias.filtro.validacao.mes.inicial.invalido'); }

      if (periodoFinal.isValid() && mesAtual.isSame(periodoFinal, 'month')) { errors.push('corregedoria.relatorio30dias.filtro.validacao.mes.final.invalido.igual.atual'); }
      if (periodoFinal.isValid() && mesPassado.isSame(periodoFinal, 'month')) { errors.push('corregedoria.relatorio30dias.filtro.validacao.mes.final.invalido.igual.passado'); }

      if (filter.tipo  === 'Corregedoria'){
        if (isBlank(filter.diasEmAtraso)) { errors.push('corregedoria.relatorio30dias.filtro.validacao.quantidade.dias.invalido'); }

        if (isNotBlank(filter.periodoInicial) && isNotBlank(filter.periodoFinal)) {
          if (filter.frequencia > (periodoFinal.diff(periodoInicial, 'months') + 1)) {
            errors.push('corregedoria.relatorio30dias.filtro.validacao.frequencia.invalida');
          }
        }
      }
      if (filter.tipo  === 'Promotor'){
        if (isBlank(filter.nomePromotor) || isBlank(filter.pessDk) ) { errors.push('corregedoria.relatorio30dias.filtro.validacao.promotor.obrigatorio'); }
      }

      return errors;
    }

    /* private */
    function isBlank(value) {
      return (value === null || value === undefined || value === '');
    }

    function isNotBlank(value) {
      return !isBlank(value);
    }

  }

})();
